/**
 * Assessment scripts
 */

$('#question_help_icon').click(function() {
    $(this).closest('p').next().slideToggle();
});

// MSD-1540: this is the sole owner of assessment Previous/Next shortcuts.
// Use the existing control so Vue still acknowledges pending saves before
// navigating. Letter shortcuts and a second inline arrow listener used to
// interrupt editing or submit the same navigation twice.
function assessmentQuestionKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (event.defaultPrevented || event.isComposing || event.repeat) return;
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

    var interactive = 'input, textarea, select, button, a[href], summary, '
        + '[role="button"], [role="link"], [role="combobox"], [role="textbox"], '
        + '[role="listbox"], [role="slider"], '
        + '[contenteditable]:not([contenteditable="false"])';
    var isInteractive = function (element) {
        return element && element.closest && element.closest(interactive);
    };
    if (isInteractive(event.target) || isInteractive(document.activeElement)) return;
    var isVisible = function (element) {
        var visibility = window.getComputedStyle(element).visibility;
        return element.getClientRects().length > 0 && visibility !== 'hidden' && visibility !== 'collapse';
    };
    var overlays = '.modal.show, .modal.in, dialog[open], [role="dialog"][aria-modal="true"], .companyListDropdown.show';
    if (Array.from(document.querySelectorAll(overlays)).some(isVisible)) return;

    var selector = event.key === 'ArrowLeft' ? '.prev_q' : '.next_q';
    // Other assessment screens also use these controls. Ignore hidden or
    // disabled variants instead of clicking every matching control via jQuery.
    var control = Array.from(document.querySelectorAll(selector)).find(function (element) {
        return !element.disabled && element.getAttribute('aria-disabled') !== 'true'
            && isVisible(element);
    });
    if (!control) return;
    event.preventDefault();
    control.click();
}
document.addEventListener('keydown', assessmentQuestionKeydown);

function companySelectorKeydown(event) {
    var keycode = event.keyCode;
    // Preserve the company selector's independent Up/Down controls.
    if($('.companyListDropdown').hasClass('show')){
        if(keycode === 40){
            //down
            if($("#companyList a").is(":focus")){
                if($(':focus').parent().nextAll(':visible').first().html() != $(':focus').parent().nextAll('li').first().html()){
                    $(':focus').parent().next('li:visible').find('a').focus();
                }
            }else{
                $('#companyList li:visible a').first().focus();
                $('.companyListContainer').animate({ scrollTop: 0 }, "fast");
            }
        }else if(keycode === 38){
            //up
            if($("#companyList a").is(":focus")){
                if($(':focus').parent().prevAll(':visible').first().html() != $(':focus').parent().prevAll('li').first().html()){
                    $(':focus').parent().prev('li:visible').find('a').focus();
                }
            }else{
                console.log('no focus');
                $('#companyList li:visible:last-child a').first().focus();
            }
        }
    }

    return;
}
document.addEventListener('keydown', companySelectorKeydown);
